'use strict';

require('../../style/index.less');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/spin/style/index.js
// module id = 334
// module chunks = 0